module.exports = __webpack_public_path__ + "img/zdd_home_banner_com.11092fad.png";